import $ from 'jquery';
import i18n, { t }  from '../i18n/i18n.js';
import MessagePopupView from '../../controls/MessagePopupView.js';
import LoadingPopupView from '../../controls/LoadingPopupView.js';
import PopupBase from './PopupBase.js';
import app from '../App.js';

var template =
    '<table class="edit-table">' +
    '  <tbody>' +
    '    <tr>' +
    '      <td><input type="radio" name="contact_reassign_options" value="ignore" id="reassign_options_ignore" checked="checked" /></td>' +
    '      <td><label for="reassign_options_ignore">{contact_reassign_options_popup.ignore_conflict_and_reassign}</label></td>' +
    '    </tr>' +
    '    <tr>' +
    '      <td><input type="radio" name="contact_reassign_options" value="end_reason" id="reassign_options_end_reason" /></td>' +
    '      <td><label for="reassign_options_end_reason">{contact_reassign_options_popup.end_reason_reassign}</label></td>' +
    '    </tr>' +
    '    <tr>' +
    '      <td></td>' +
    '      <td><select name="reassign_options_end_reasons"></select></td>' +
    '    </tr>' +
    '  </tbody>' +
    '</table>';

var templateActions =
    '<div class="popup-actions">' +
    '  <button class="cancel-button">{cancel}</button>' +
    '  <button class="save-button">{save}</button>' +
    '</div>';

var ContactReassignOptionsPopup = PopupBase.extend({

    className: 'popup-frame medium-size',
    hasAutoReposition: false,
    hasContentArea: false,

    initialize: function (options) {

        options = options || {};
        if (!options.title) {
            if (options.count != null) {
                options.title = t('contact_reassign_options_popup.title_count', { count: options.count });
            } else {
                options.title = t('contact_reassign_options_popup.title');
            }
        }

        if (options.contacts) {
            this.hasAutoReposition = true;
            this.hasContentArea = true;
        }

        ContactReassignOptionsPopup.__super__.initialize.call(this, options);

        var that = this;

        that.options = options;

        that.$content.before(i18n.processLocalizedString(template));
        that.$content.before(i18n.processLocalizedString(templateActions));

        that.$el.find('select[name=reassign_options_end_reasons]').on('change', function () {
                that.$el.find('input[name=contact_reassign_options][value=end_reason]').prop('checked', true);
            });

        if (options.contacts) {

            var $table = that._$table = $(i18n.processLocalizedString('' +
                '<table class="simple-table">' +
                '<thead><tr><th>{contact_reassign_options_popup.contact_name}</th><th>{contact_reassign_options_popup.campaign_name}</th></tr></thead>' +
                '<tbody></tbody>' +
                '</table>'
            )).appendTo(that.$content),
                $tbody = $table.find('tbody');

            options.contacts.forEach(function (contact) {
                $('<tr>').append(
                    $('<td>').text(((contact['first_name'] || '') + ' ' + (contact['last_name'] || '')).trim()),
                    $('<td>').text(contact['campaign_name'] || '?')
                ).appendTo($tbody);
            });
        }

        that.$el.find('.cancel-button').click(that.onCancel.bind(that));
        that.$el.find('.save-button').click(that.onSave.bind(that));

        that.fetchEndReasons();
    },

    fetchEndReasons: function () {
        var that = this;

        var loader = that._loader = new LoadingPopupView(t('activity_indicator.loading'));

        that.setTimeout(function () { // Do after rendering to screen
            loader.show(that.$el);

            var params = {
                'project_id': that.options.projectId,
                'defaults': 'yes'
            };

            that.ajaxGet(app.apiUrl('end_reasons', params))
                .always(function () {
                    loader.hide();
                })
                .then(function(rows) {

                    that._endReasons = rows;

                    var $select = that.$el.find('select[name=reassign_options_end_reasons]');
                    rows.forEach(function (item) {
                        $('<option>').val(item['id']).text(item['name']).appendTo($select);
                    });

                })
                .fail(function(xhr, error) {
                    app.showXhrError(xhr, error);
                });

        }, 0);

        return that;
    },

    assignLeadToUser: function (user) {

        var that = this;

        var apiUrl = app.apiUrl('leads/' + encodeURIComponent(that.options.leadId) + '/assign');

        var data = { 'user_id': user['id'] };

        that.ajaxJsonPost(apiUrl, data)
            .always(function () {
                app.AlertUI.hideLoader();
            })
            .then(function (response) {
                new MessagePopupView({addClass: 'done', message: t('assign_lead_popup.saved_prompt'), queue: true}).show();
                that.trigger('assign', { leadId: response['id'], queue: response['queue'], user: user });
                that.hide();
            })
            .fail(function (xhr, error) {
                app.showXhrError(xhr, error);
            });

        return that;

    },

    onCancel: function () {
        return this.trigger('cancel').hide();
    },

    onSave: function () {
        var that = this;

        that.$el.find('input,textarea,select').removeClass('invalid');

        var data = {};
        data.mode = that.$el.find('input[name=contact_reassign_options]:checked').val();
        data.endReasonId = that.$el.find('select[name=reassign_options_end_reasons]').val();

        if (data.mode === 'end_reason' && !data.endReasonId) {
            that.$el.find('select[name=reassign_options_end_reasons]').addClass('invalid');
            return that;
        }

        return that.trigger('save', data).hide();
    },

    remove: function () {
        var that = this;

        if (that._loader) {
            that._loader.remove();
        }

        ContactReassignOptionsPopup.__super__.remove.apply(this, arguments);
    }

});

export default ContactReassignOptionsPopup;
